// // components/FlipCard.js
// import React from "react";
// import "../styles/FlipCard.css"; // Import your CSS file for styling

// const FlipCard = ({ frontText, backText, buttonLabel, onClick }) => (
//   <div className="flip-card">
//     <div className="flip-card-inner">
//       <div className="flip-card-front">
//         <p>{frontText}</p>
//       </div>
//       <div className="flip-card-back">
//         <p>{backText}</p>
//         <button onClick={onClick} className="mt-2 px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700">
//           {buttonLabel}
//         </button>
//       </div>
//     </div>
//   </div>
// );

// export default FlipCard;


import React from "react";
import "../styles/FlipCard.css";
import { useNavigate } from "react-router-dom";

const FlipCard = ({ patient, buttonLabel }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/consult", { state: { patient } });
  };

  return (
    <div className="flip-card">
      <div className="flip-card-inner">
        <div className="flip-card-front">
          <div className="front-overlay">
            <h2 className="text-xl font-bold text-center">
              {patient["Patient Name"]}
              <br />
              <span className="font-medium text-base">
                "{patient["Patient Quote"]}"
              </span>
            </h2>
          </div>
        </div>
        <div className="flip-card-back">
          <ul className="p-4 space-y-2 text-sm">
            <li>👤 <strong>Name:</strong> {patient["Patient Name"]}</li>
            <li>🎂 <strong>Age:</strong> {patient["Age"]}</li>
            <li>🩺 <strong>Clinical Summary:</strong> {patient["Clinical Summary"]}</li>
            <li>🗣️ <strong>Quote:</strong> "{patient["Patient Quote"]}"</li>
            <li>👩‍⚕️ <strong>Prompt:</strong> {patient["Voice Prompt to Doctor"]}</li>
          </ul>
          <div className="px-4 pb-4">
            <button
              onClick={handleClick}
              className="w-full bg-[#1D3A73] text-white py-1 rounded hover:bg-[#1D3A73]"
            >
              {buttonLabel || "Start Consult"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FlipCard;
